import React, { ReactNode, useEffect } from "react";

import { useNavigate, useLocation } from "react-router-dom";

import { useAppSelector } from "../store/hooks";

interface ServiceGuardProps {
  children: ReactNode;
}

/**
 * Route guard component that ensures a service is selected before allowing access to protected routes
 */
export const ServiceGuard: React.FC<ServiceGuardProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const selectedService = useAppSelector((state) => state.service.selectedService);

  useEffect(() => {
    // Don't redirect if we're already on the service selection page
    if (location.pathname === "/services") {
      return;
    }

    // If no service is selected, redirect to service selection
    if (!selectedService) {
      navigate("/services", { replace: true });
    }
  }, [selectedService, navigate, location.pathname]);

  // Don't render children if no service is selected
  if (location.pathname !== "/services" && !selectedService) {
    return null;
  }

  return <>{children}</>;
};

export default ServiceGuard;
